import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link, Route, Switch } from 'react-router-dom';

import { graphql, gql, compose } from 'react-apollo';

import { Tabs, Tab } from 'material-ui/Tabs';

import Loader from '../../UI/Loader';
import ParticipantsTable from '../ParticipantsTable';
import UploadTownPapers from '../UploadTownPapers';

import styles from './Town.css';

const townQuery = gql`
    query TownQuery($townId: ID!) {
        town(_id: $townId) {
            _id
            name {
                ru
                local
            }
            region
            tournament {
                _id
                number
                p {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                m {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                t {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                v {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                gradeSettings {
                    number
                    level
                    multiplier
                    russianEquivalent
                }
                criteria {
                    p {
                        junior
                        senior
                    }
                    m {
                        junior
                        senior
                    }
                    t {
                        junior
                        senior
                    }
                    v {
                        junior
                        senior
                    }
                }
            }
            gradeSettings {
                number
                level
                multiplier
                russianEquivalent
            }
            participants {
                _id
                name
                grade
                email
                school
                papers {
                    _id
                    round
                    level
                    filename
                    file
                    marks
                    juryMarks {
                        user {
                            _id
                            name
                        }
                        mark
                        problemName
                        stage
                    }
                    pages {
                        _id
                        file
                        rotation
                        comments {
                            _id
                            user {
                                _id
                                name
                            }
                            path
                            style
                            text
                        }
                    }
                }
            }
            reportToken
            batches {
                jury {
                    _id
                    name
                }
                round
                level
                stage
                start
                end
            }
        }
    }
`;

const stopBatchMarkingMutation = gql`
    mutation StopBatchMarkingMutation($townId: ID!, $round: String, $level: String, $stage: String) {
        stopBatchMarking(townId: $townId, round: $round, level: $level, stage: $stage) {
            jury {
                name
            }
        }
    }
`;

class Town extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            town: PropTypes.object,
            refetch: PropTypes.func.isRequired,
        }).isRequired,
        isAdmin: PropTypes.bool,
    };

    state = {
        uploaded: false,
    };

    handlePaperClose = () => {
        this.props.data.refetch();
    };

    handleUploaded = () => {
        this.setState({
            uploaded: true,
        });
    };

    handleToParticipantsClick = () => {
        this.props.data.refetch();

        this.setState({
            uploaded: false,
        });
    };

    handleBatchMarkingClick = async (event, round, level, stage) => {
        const {
            stopBatchMarking,
            data: { town, refetch },
        } = this.props;

        await stopBatchMarking({
            variables: {
                townId: town._id,
                round,
                level,
                stage,
            },
        });

        refetch();
    };

    renderBatchesInfo = (round, level) => {
        const {
            data: {
                town: { batches = [] },
            },
            user,
        } = this.props;
        const ownBatch = batches.find(
            batch => batch.round === round && batch.level === level && !batch.end && batch.jury._id === user._id
        );

        const activeBatch =
            user.role === 'admin' &&
            batches.find(
                batch => batch.round === round && batch.level === level && !batch.end && batch.jury._id !== user._id
            );

        return (
            <Fragment>
                {!!batches.length && (
                    <Fragment>
                        Проверяли: {[...new Set(batches.map(({ jury: { name } }) => name))].join(', ')}
                        <br />
                        <br />
                    </Fragment>
                )}
                {ownBatch && (
                    <span
                        className={styles.stopMarking}
                        onClick={e => this.handleBatchMarkingClick(e, round, level, ownBatch.stage)}
                    >
                        Закончить проверку
                    </span>
                )}
                {!ownBatch &&
                    activeBatch && (
                        <span
                            className={styles.stopMarking}
                            onClick={e => this.handleBatchMarkingClick(e, round, level, activeBatch.stage)}
                        >
                            Отобрать пачку
                        </span>
                    )}
            </Fragment>
        );
    };

    render() {
        const {
            intl: { formatMessage },
            data: { town, loading },
            isAdmin,
            match: {
                params: { season },
            },
        } = this.props;
        const { uploaded } = this.state;

        if (loading) {
            return <Loader centerX />;
        }

        if (!town) {
            return (
                <h2>
                    <FormattedMessage id="Town.No such town" />
                </h2>
            );
        }

        return (
            <div className={styles.wrapper}>
                <h2>{town.name.ru || town.name.local}</h2>
                <Tabs
                    value={season}
                    onChange={season =>
                        this.props.history.push(`/tournaments/${town.tournament.number}/towns/${town._id}/${season}`)
                    }
                    tabItemContainerStyle={{ background: 'transparent' }}
                >
                    <Tab
                        label={formatMessage({ id: 'OrgHomePage.fall' })}
                        style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                        value="fall"
                    />
                    {Boolean(town.tournament.t && town.tournament.v) && (
                        <Tab
                            label={formatMessage({ id: 'OrgHomePage.spring' })}
                            style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                            value="spring"
                        />
                    )}
                </Tabs>
                <br />
                <Switch>
                    {isAdmin && (
                        <Route
                            path={`/tournaments/:number/towns/:townId/:season/upload`}
                            render={({ match }) =>
                                uploaded ? (
                                    <Fragment>
                                        <FormattedMessage id="Town.success upload" />
                                        &nbsp;
                                        <Link
                                            to={`/tournaments/${match.params.number}/towns/${town._id}/${season}`}
                                            onClick={this.handleToParticipantsClick}
                                        >
                                            <FormattedMessage id="Town.to participants" />
                                        </Link>
                                    </Fragment>
                                ) : (
                                    <UploadTownPapers
                                        town={town}
                                        season={season}
                                        onParticipantsRegistered={this.handleUploaded}
                                    />
                                )
                            }
                        />
                    )}
                    <Route
                        path={`/tournaments/:number/towns/:townId/:season/:round(p|m|t|v)/:level(junior|senior)`}
                        render={({
                            match: {
                                params: { round, level },
                            },
                        }) => {
                            const participants = town.participants
                                .filter(({ papers }) =>
                                    papers.some(paper => paper.round === round && paper.level === level)
                                )
                                .map(({ papers, ...rest }) => ({
                                    ...rest,
                                    papers: papers.filter(paper => paper.round === round && paper.level === level),
                                }));

                            return (
                                <Fragment>
                                    <h3>
                                        <FormattedMessage id={`TownsList.${round}.${level}`} />
                                    </h3>
                                    {this.renderBatchesInfo(round, level)}
                                    {participants.length ? (
                                        <ParticipantsTable
                                            participants={participants}
                                            gradeSettings={town.gradeSettings}
                                            tournament={town.tournament}
                                            onPaperClose={this.handlePaperClose}
                                            season={season}
                                            batchMode={true}
                                        />
                                    ) : (
                                        <div className={styles.noParticipants}>
                                            <FormattedMessage id="Town.no participants" />
                                        </div>
                                    )}
                                </Fragment>
                            );
                        }}
                    />
                    <Route
                        render={({ match }) => (
                            <Fragment>
                                {isAdmin && (
                                    <div className={styles.townLinks}>
                                        <a
                                            href={`/report/${
                                                ['экс-СССР', 'Россия'].includes(town.region) ? 'ru' : 'en'
                                            }/${town.reportToken}`}
                                            target="_blank"
                                        >
                                            <FormattedMessage id="Town.report" />
                                        </a>
                                        <Link to={`/tournaments/${match.params.number}/towns/${town._id}/merge`}>
                                            <FormattedMessage id="Town.deduplicate" />
                                        </Link>
                                        <Link
                                            to={`/tournaments/${match.params.number}/towns/${
                                                town._id
                                            }/${season}/upload`}
                                        >
                                            <FormattedMessage id="Town.upload papers" />
                                        </Link>
                                    </div>
                                )}
                                {town.participants.length ? (
                                    <ParticipantsTable
                                        participants={town.participants.filter(
                                            ({ papers }) =>
                                                season === 'fall'
                                                    ? papers.some(paper => ['p', 'm'].includes(paper.round))
                                                    : papers.some(paper => ['t', 'v'].includes(paper.round))
                                        )}
                                        gradeSettings={town.gradeSettings}
                                        tournament={town.tournament}
                                        onPaperClose={this.handlePaperClose}
                                        season={season}
                                    />
                                ) : (
                                    <div className={styles.noParticipants}>
                                        <FormattedMessage id="Town.no participants" />
                                    </div>
                                )}
                            </Fragment>
                        )}
                    />
                </Switch>
            </div>
        );
    }
}

export default compose(
    graphql(townQuery, {
        options: ({ match }) => ({ variables: { townId: match.params.id }, fetchPolicy: 'no-cache' }),
    }),
    graphql(stopBatchMarkingMutation, { name: 'stopBatchMarking' }),
    injectIntl
)(Town);



// WEBPACK FOOTER //
// ./src/Components/Town/Town.js